import './css/App.css';
import { Home } from './pages/Home';
import { Suspense } from 'react';
import { Nav } from './pages/Nav';
import Login from './pages/Login';
import { About } from './pages/About';
import Profile from './pages/Profile';
import Register from './pages/Register';
import { Toaster } from 'react-hot-toast';
import { Loader } from './components/Loader';
import { EventFlyer } from './pages/EventFlyer';
import { PublicProfile } from './pages/PublicProfile';
import { UserProvider } from './context/UserProvider';
import { VideoMediaDisplay } from './pages/VideoMediaDetail';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PublicDataProvider } from './context/PublicDataProvider';
import { MediaPlayerProvider } from './context/MediaPlayerProvider';
import { ChatMessageProvider } from './context/DMProvider';
import { CartProvider } from './context/CartProvider';
import { BattleProvider } from './context/BattleProvider';
import { BattlePage } from './pages/BattlePage';

function App() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <MediaPlayerProvider>
          <PublicDataProvider>
            <UserProvider>
              <ChatMessageProvider>
                <CartProvider>
                  <BattleProvider>
                    <BrowserRouter>
                      <Toaster />
                      <Routes>
                        <Route path="/" element={<Nav />}>
                          <Route path="/" element={<Home />} />
                          <Route path="/about" element={<About />} />
                          <Route path="/login" element={<Login />} />
                          <Route path="/profile" element={<Profile />} />
                          <Route path="/register" element={<Register />} />
                          <Route path="/profile/:id" element={<PublicProfile />} />
                          <Route path="/media/:id" element={<VideoMediaDisplay />} />
                          <Route path="/event/:id/:attending" element={<EventFlyer />} />
                          <Route path="/battle" element={<BattlePage />} />
                          <Route path="/battle/:sessionId" element={<BattlePage />} />
                        </Route>
                      </Routes>
                    </BrowserRouter>
                  </BattleProvider>
                </CartProvider>
              </ChatMessageProvider>
            </UserProvider>
          </PublicDataProvider>
        </MediaPlayerProvider>
      </Suspense>
    </>
  );
}

export default App;
